<template lang="pug">
  div.members
    button.search_btn(type="button" @click="openSearch")
      IconBase(width="25" height="25" icon-name="search")
          IconSearch()
    button.disp_layout(type="button" @click="changeZoom")
      IconBase(width="25" height="25" icon-name="layouts")
        IconTh(v-if="isZoom")
        IconThLarge(v-else)

    .search_box(v-if="isOpenSearch")
      input#name(type="search" v-model="searchInput" @change="searchDone" placeholder="名前 or メールアドレス")
    ul.department_list
      li.department_item(v-for="departmentGroup in groupByDepartment" :key="Object.keys(departmentGroup).shift()")
        h2(:id="'department_' + Object.keys(departmentGroup).shift()")
          span {{ Object.keys(departmentGroup).shift() | convertMasterName('departments', master) }}
            small （{{ departmentGroup[Object.keys(departmentGroup).shift()].length }}名）
        ul.member_list(:class="{unZoom: !isZoom}")
          li.member(v-for="user in departmentGroup[Object.keys(departmentGroup).shift()]" :key="user.id")
            MemberItem(:account="user")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MemberItem from '@/components/MemberItem'
import IconBase from '@/components/IconBase.vue'
import IconSearch from '@/components/icons/IconSearch.vue'
import IconTh from '@/components/icons/IconTh.vue'
import IconThLarge from '@/components/icons/IconThLarge.vue'
export default {
  name: 'MembersView',
  metaInfo: {
    title: '社員一覧画面',
  },
  data() {
    return {
      isZoom: null,
      isOpenSearch: false,
      searchInput: '',
    }
  },
  components: {
    MemberItem,
    IconBase,
    IconSearch,
    IconTh,
    IconThLarge,
  },
  computed: {
    ...mapState('authModule', ['account']),
    ...mapState('usersModule', ['users']),
    ...mapState('masterModule', ['master']),
    groupByDepartment() {
      const array = {}
      Object.keys(this.users).forEach((id) => {
        let account = this.users[id]
        if (this.searchInput) {
          if (
            !account.name.includes(this.searchInput) &&
            !account.email.includes(this.searchInput)
          ) {
            return false
          }
        }
        if (!(account.departmentId in array)) {
          array[account.departmentId] = []
        }
        array[account.departmentId].push(account)
      })
      Object.keys(array).forEach((departmentId) => {
        array[departmentId].sort(
          (a, b) =>
            this.master.positions[a.positionId].sortId -
            this.master.positions[b.positionId].sortId,
        )
      })
      let sortDepartment = Object.keys(array).sort(
        (a, b) =>
          this.master.departments[a].sortId - this.master.departments[b].sortId,
      )
      let resutl = []
      sortDepartment.forEach((departmentId) => {
        resutl.push({ [departmentId]: array[departmentId] })
      })
      return resutl
    },
  },
  created() {
    this.isZoom =
      typeof this.account.isZoom == 'undefined' ? true : this.account.isZoom
  },
  methods: {
    ...mapActions('authModule', ['updateAccount']),
    async changeZoom() {
      this.isZoom = !this.isZoom
      await this.updateAccount({
        isZoom: this.isZoom,
      })
    },
    openSearch() {
      this.isOpenSearch = !this.isOpenSearch
    },
    searchDone() {
      this.isOpenSearch = false
    },
  },
}
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.members {
  .search_btn {
    position: fixed;
    line-height: 1;
    top: 10px;
    right: 50px;
    padding: 0;
    font-size: 25px;
    color: #666;
    z-index: 20;
    cursor: pointer;
    animation: fadeIn 3s ease 0s 1 normal;
    -webkit-animation: fadeIn 3s ease 0s 1 normal;
  }
  .search_box {
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    padding: 7px 10px;
    z-index: 20;
    background-color: #f6f6f6;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    input {
      width: 100%;
      text-align: left;
      border-radius: 4px;
      border: 1px solid #d1d1d1;
      padding: 7px 10px;
      font-size: 15px;
      font-weight: normal;
    }
  }
  .disp_layout {
    position: fixed;
    line-height: 1;
    top: 10px;
    right: 13px;
    padding: 0;
    font-size: 25px;
    color: #666;
    z-index: 20;
    cursor: pointer;
    animation: fadeIn 3s ease 0s 1 normal;
    -webkit-animation: fadeIn 3s ease 0s 1 normal;
  }
  @include noZoom {
    .disp_layout {
      display: none;
    }
    .search_btn {
      right: 13px;
    }
    .search_box {
      input {
        max-width: 430px;
      }
    }
  }
}
.department_list {
  margin: 10px 0 0;
  .department_item {
    h2 {
      position: sticky;
      top: 0;
      z-index: 15;
      background: #fff;
      padding: 15px;
      text-align: left;
      font-weight: bold;
      span {
        display: block;
        max-width: 1020px;
        margin: 0 auto;
      }
      @include iphone5 {
        font-size: 13px;
      }
      @include pc {
        text-align: left;
        padding: 15px 5px 15px 20px;
      }
      small {
        font-size: 13px;
      }
    }
    .member_list {
      display: flex;
      flex-wrap: wrap;
      margin: 10px auto 0;
      padding: 0 8px;
      @include pc {
        padding: 0 15px;
      }
      max-width: 1020px;
      .member {
        @include noZoom {
          width: calc(100% / 3 - 16px) !important;
        }
        @include tab {
          width: calc(100% / 4 - 16px) !important;
        }
        @include pc {
          width: calc(100% / 5 - 16px) !important;
        }
        @include max {
          width: calc(100% / 6 - 16px) !important;
        }
        width: calc(50% - 16px);
        padding: 0 8px;
        margin: 10px 0 25px;
        transition: all 0.4s;
      }
      &.unZoom {
        .member {
          width: calc(100% / 3 - 16px);
        }
      }
    }
  }
}
</style>
<style>
.unZoom .member_item a .img_wrap .position {
  font-size: 10px;
  bottom: -7px;
}
</style>
